import { render, staticRenderFns } from "./TransactionHistory.vue?vue&type=template&id=424fdcec&scoped=true&"
import script from "./TransactionHistory.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TransactionHistory.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TransactionHistory.vue?vue&type=style&index=0&id=424fdcec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424fdcec",
  null
  
)

export default component.exports